export enum OrderTimeInForce {
  GTC = 'gtc',
  IOC = 'ioc',
  DAY = 'day',
  OPG = 'opg',
  FOK = 'fok',
  CLS = 'cls',
}

export enum OrderType {
  MARKET = 'market',
  LIMIT = 'limit',
  STOP = 'stop',
  STOP_LIMIT = 'stop_limit',
  TRAILING_STOP = 'trailing_stop',
}

export enum OrderSide {
  BUY = 'buy',
  SELL = 'sell',
}

export enum OrderApprovalStatus {
  APPROVED = 'Approved',
  QUEUED = 'Queued',
  DECLINED = 'Declined',
}

export enum OrderClass {
  SIMPLE = 'simple',
  BRACKET = 'bracket',
  OCO = 'oco',
  OTO = 'oto',
}

export enum OrderRestriction {
  STOCK = 'STOCK',
  CRYPTO = 'CRYPTO',
}

export enum OrderStatus {
  NEW = 'new',
  PARTIALLY_FILLED = 'partially_filled',
  FILLED = 'filled',
  DONE_FOR_DAY = 'done_for_day',
  CANCELED = 'canceled',
  EXPIRED = 'expired',
  REPLACED = 'replaced',
  PENDING_CANCEL = 'pending_cancel',
  PENDING_REPLACE = 'pending_replace',
  ACCEPTED = 'accepted',
  PENDING_NEW = 'pending_new',
  ACCEPTED_FOR_BIDDING = 'accepted_for_bidding',
  STOPPED = 'stopped',
  REJECTED = 'rejected',
  SUSPENDED = 'suspended',
  CALCULATED = 'calculated',
}

export interface CreateOrderBody {
  symbol: string;
  type?: OrderType;
  time_in_force?: OrderTimeInForce;
  notional?: string | number;
  qty?: number;
  side: OrderSide;
  userId: string;
  isCrypto: boolean;
  sellAll?: boolean;
}

export interface CreateOrderResponse {
  isOrderCreated: boolean;
  message: string;
  isFilled?: boolean;
}

export interface IRecordOfAny {
  [key: string]: any;
}


export interface OrderRequest {
  id: string;
  symbol: string;
  qty?: number | string | null;
  notional?: number | string | null;
  side: OrderSide;
  type: OrderType;
  time_in_force: OrderTimeInForce;
  limit_price?: number;
  stop_price?: number;
  trail_price?: number;
  trail_percent?: number;
  extended_hours?: boolean;
  client_order_id?: string;
  order_class?: OrderClass;
  take_profit?: any;
  stop_loss?: any;
  commission?: number;
  createdAt?: string;
  updatedAt?: string;
  status?: string;
  metadata?: {
    image?: string;
    name?: string;
  }
  approvalStatus: OrderApprovalStatus;
  sellAll: boolean;
  isCrypto: boolean;
}

export interface Order {
  id: string;
  client_order_id: string;
  created_at: string;
  updated_at: string;
  submitted_at: string;
  filled_at: null;
  expired_at: null;
  canceled_at: null;
  failed_at: null;
  replaced_at: null;
  replaced_by: null;
  replaces: null;
  asset_id: string;
  symbol: string;
  asset_class: string;
  notional: string;
  qty: null;
  filled_qty: string;
  filled_avg_price: null;
  order_class: string;
  order_type: string;
  type: string;
  side: string;
  time_in_force: string;
  limit_price: null;
  stop_price: null;
  status: OrderStatus;
  extended_hours: boolean;
  legs: null;
  trail_percent: null;
  trail_price: null;
  hwm: null;
  commission: number;
  swap_rate?: string | number;
  swap_fee_bps?: string | number;
  usd?: {
    notional: string;
    filled_avg_price: string;
  };
  metadata?: {
    image?: string;
    name?: string;
  }
}

export interface PendingOrders {
  scheduledOrders: Order[];
  orderRequests: OrderRequest[];
}

export interface GetOrdersQueryParams {
  status?: "open" | "closed" | "all";
  limit?: number;
  after?: string;
  until?: string;
  direction?: string;
  nested?: boolean;
  symbols?: string; // comma-separated list of symbols
  qty_above?: string | number;
  qty_below?: string | number;
  subtag?: string;
  includeMetadata?: boolean;
}

export interface GetOrderRequestsQueryParams {
  includeMetadata?: boolean;
}

export interface GetPendingOrdersQueryParams {
  includeMetadata?: boolean;
}